import { Box, useTheme, useMediaQuery } from "@mui/material"
import imageCompression from 'browser-image-compression';
import { PDFDocument } from 'pdf-lib';
import { v4 as uuidv4 } from 'uuid';

export const AppBarPadding = ({pt = 10}) => {
    const themeX = useTheme();
    const isMobile = useMediaQuery(themeX.breakpoints.down("md"))
    return (<Box sx={{ pt: isMobile ? pt : 10 }} />)
}
export const BottomPadding = () => {
    const themeX = useTheme();
    const isMobile = useMediaQuery(themeX.breakpoints.down("md"))

    return (<Box sx={{ pb: isMobile? 5: 10 }} />)
}

export const checkSuccess = (response) => {
    return response && response.status >= 200 && response.status < 300;
};

export const formatApiError = (error, defaultMessage = "An error occurred.") => {
    const fallback = error?.message || defaultMessage;

    if (!error?.response?.data) {
        return fallback;
    }

    const data = error.response.data;

    if (typeof data === "string") {
        return `${defaultMessage} ${data}`;
    }

    if (typeof data === "object") {
        
        const formatted = Object.entries(data)
            .map(([field, messages]) =>
                `${capitalize(field)}: ${Array.isArray(messages) ? messages.join(", ") : messages}`
            )
            .join(" | ");
        return `${defaultMessage} ${formatted}`;
    }

    return fallback;
};

export const handleShare = (title="", text="") => {
    if (navigator.share) {
        navigator.share({
            title: title,
            text: text,
            url: window.location.href, // Dynamically share the current page URL
        })
            .then(() => console.log("Shared successfully!"))
            .catch((error) => console.error("Error sharing:", error));
    } else {
        alert("Sharing is not supported on this device.");
    }
};

export const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const isValidURL = (string) => {

    try {
        new URL(string);
        return true;
    } catch (_) {
        return false;
    }
}

export function getFileExtension(fileOrUri) {
    if (typeof fileOrUri === 'string') {
        return fileOrUri.split('.').pop().split('?')[0].split('#')[0].toLowerCase();
    }

    if (fileOrUri instanceof File) {
        return fileOrUri.name.split('.').pop().toLowerCase();
    }

    return ''; // fallback if unknown type
}

export function generateSocialMediaUrl(socialMediaList) {
    const baseUrls = {
        instagram: 'https://www.instagram.com/',
        x: 'https://x.com/',
        tiktok: 'https://www.tiktok.com/@',
        facebook: 'https://www.facebook.com/',
    };

    const output = {};

    for (const { platform, username } of socialMediaList) {
        if (!platform || !username || !baseUrls[platform]) {
            continue; // skip invalid entries
        }

        const platformKey = `${platform}_url`;
        output[platformKey] = `${baseUrls[platform]}${username}`;
    }

    return output;
}

export function parseAllSocialMediaUrls(socialUrls) {
    const baseUrls = {
        instagram: 'https://www.instagram.com/',
        x: 'https://x.com/',
        tiktok: 'https://www.tiktok.com/@',
        facebook: 'https://www.facebook.com/',
    };

    const results = [];

    for (const [key, url] of Object.entries(socialUrls)) {
        if (url && typeof url === 'string') {
            const platform = key.replace('_url', '');
            const base = baseUrls[platform];
            if (base && url.startsWith(base)) {
                const username = url.replace(base, '').replace(/\/+$/, '');
                results.push({ platform, username });
            }
        }
    }

    return results;
}

export const normalize = (str) =>
    str?.toLowerCase().replace(/[^a-z0-9]/gi, ''); // removes all non-alphanumeric characters

export async function compressAndRenameFile(uploadFile, key) {
    if (!(uploadFile instanceof File)) {
        throw new Error("Invalid file provided.");
    }

    const isImage = uploadFile.type.startsWith("image/");
    const isPDF = uploadFile.type === "application/pdf";

    const timestamp = new Date().toISOString().replace(/[-:.]/g, '');
    const extension = getFileExtension(uploadFile);
    const newFileName = `${key}_${timestamp}_${uuidv4()}.${extension}`;

    try {
        if (isImage) {
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1024,
                useWebWorker: true,
            };

            const compressedImage = await imageCompression(uploadFile, options);
            return new File([compressedImage], newFileName, {
                type: compressedImage.type,
            });

        } else if (isPDF) {
            const arrayBuffer = await uploadFile.arrayBuffer();
            const pdfDoc = await PDFDocument.load(arrayBuffer);
            const compressedPdfBytes = await pdfDoc.save({ useObjectStreams: false });

            return new File([compressedPdfBytes], newFileName, {
                type: "application/pdf",
            });
        } else {
            // Just rename for unsupported types
            return new File([uploadFile], newFileName, {
                type: uploadFile.type,
            });
        }
    } catch (error) {
        console.error("Compression failed:", error);
        throw error;
    }
}
